import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';
import { getMfaTrustedDevice } from '@hotjar/webapp/domains/mfa/api';
import type { MfaTrustedDeviceModel } from '@hotjar/webapp/domains/mfa/model';

const MFA_TRUSTED_DEVICES_QUERY_KEY = 'MFA_TRUSTED_DEVICES_QUERY_KEY';

export const useMfaTrustedDevices = (
  userId?: number,
): UseQueryResult<MfaTrustedDeviceModel[], Error> =>
  useQuery({
    queryKey: [MFA_TRUSTED_DEVICES_QUERY_KEY, userId],
    queryFn: () => {
      if (userId) {
        return getMfaTrustedDevice(userId);
      }
      return [];
    },
  });
